import { SalesMetrosApi } from '../clients';

/**
 * The zips one sales metro owns, in the order the service returns them.
 *
 * @param {string} salesMetroId
 * @returns {Promise<string[]>} Empty, never null.
 */
export const getSalesMetroZips = async (salesMetroId) => {
  const response = await SalesMetrosApi.getSalesMetroZips(salesMetroId);

  return response?.zips ?? [];
};
